import { render, staticRenderFns } from "./mo-environment-header.html?vue&type=template&id=36ce728a&scoped=true&external"
import script from "./mo-environment-header.ts?vue&type=script&lang=ts&external"
export * from "./mo-environment-header.ts?vue&type=script&lang=ts&external"
import style0 from "./mo-environment-header.vue?vue&type=style&index=0&id=36ce728a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ce728a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/agent/_work/9/s/Be.Vlaanderen.Mo.Vue/ClientApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36ce728a')) {
      api.createRecord('36ce728a', component.options)
    } else {
      api.reload('36ce728a', component.options)
    }
    module.hot.accept("./mo-environment-header.html?vue&type=template&id=36ce728a&scoped=true&external", function () {
      api.rerender('36ce728a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/mo-environment-header/mo-environment-header.vue"
export default component.exports